/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */
import {Redirect, Route, Switch} from "react-router-dom";
import HomeView from "./views/home-view";
import PersonListView from "./views/personList-view";
import PersonDetailsView from "./views/personDetails-view";
import Error404View from "./views/error-404-view";
import CustomerListView from "./views/customerList-view";
import DeviceListView from "./views/deviceList-view";
import UserListView from "./views/userList-view";
import DeviceModelListView from "./views/devicemodelList-view";
import SelfView from "./views/self-view";
import CustomerDetailsView from "./views/customerDetails-view";
import DeviceDetailsView from "./views/deviceDetails-view";
import FilterSettingsView from "./views/filterSettings-view";
import UserDetailsView from "./views/userDetails-view";
import DeviceReportView from "./views/deviceReport-view";
import DeviceColumnMappingView from "./views/deviceColumnMapping-view";
import DokumentationView from "./views/documentation-view";
import TodoListView from "./views/todoList-view";

export default function AppRoutes(props: any) {
    return (
        <Switch>
            {/* Home */}
            <Route exact path='/'>
                <Redirect to={'/customers'}></Redirect>
                {/*TODO reactivate <HomeView/>*/}
            </Route>

            {/* Persons / Contacts */}
            <Route exact path='/persons'>
                <PersonListView/>
            </Route>
            <Route exact path='/persons/:id'>
                <PersonDetailsView/>
            </Route>

            {/* Customers */}
            <Route exact path='/customers'>
                <CustomerListView/>
            </Route>
            <Route exact path='/customers/:id'>
                <CustomerDetailsView/>
            </Route>

            {/* DeviceModels */}
            <Route exact path='/models'>
                <DeviceModelListView/>
            </Route>

            {/* Devices */}
            <Route exact path='/devices'>
                <DeviceListView/>
            </Route>
            <Route exact path='/devices/:id'>
                <DeviceDetailsView/>
            </Route>
            <Route exact path='/devices/:id/report'>
                <DeviceReportView/>
            </Route>
            <Route exact path='/devices/:id/columnmapping'>
                <DeviceColumnMappingView/>
            </Route>

            {/* Users */}
            <Route exact path='/users'>
                <UserListView/>
            </Route>
            <Route exact path='/users/:id'>
                <UserDetailsView/>
            </Route>

             {/* Todos*/}
            <Route exact path='/todos'>
                <TodoListView/>
            </Route>

            {/* Settings*/}
            <Route exact path='/settings'>
                <SelfView/>
            </Route>

            {/* FilterSetting */}
            <Route exact path='/eventfilters'>
                <FilterSettingsView/>
            </Route>

            <Route exact path='/documentation'>
                <DokumentationView/>
            </Route>

            {/* Default */}
            <Route path="*">
                <Error404View/>
            </Route>

        </Switch>
    )
}